import Localization from "./localization";

export default Localization;
